import { createContext } from 'react'

const PreferencesContext = createContext({})

export default PreferencesContext
